import request from '@/server/request'

export default {
  async initializeCheckout ({ rootGetters }, payload) {
    return request({ entity: 'payments.liqpay.checkout', action: 'init' }, rootGetters['user/getAccessToken'], 'GET', payload)
  }
}
